import { useQuery } from '@tanstack/react-query';
import { GET_CHATS_FOR_DOMAIN } from '../../../../query/monitor/data/sources/keys';
import {
  getChatsForDomain,
  ChatsForDomainResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

export const useGetChatsForDomain = (
  projectId: number | null,
  domain: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  page?: number,
  pageSize?: number,
  keyword?: string,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: chatsForDomain,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<ChatsForDomainResponse>({
    queryKey: [
      GET_CHATS_FOR_DOMAIN,
      projectId,
      domain,
      chatType,
      fromTimestamp,
      toTimestamp,
      page,
      pageSize,
      keyword,
      monitorPromptIds,
      filterMonitorTypes,
    ],
    queryFn: () =>
      getChatsForDomain(projectId!, domain, chatType!, from, to, page, pageSize, keyword, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    chatsForDomain: queryEnabled ? chatsForDomain ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
  };
};
